// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUpdatePayoutRuleTypeDto
 */
export interface IUpdatePayoutRuleTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IUpdatePayoutRuleTypeDto
     */
    processing_tier_id: number;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePayoutRuleTypeDto
     */
    payout_rule_type: IUpdatePayoutRuleTypeDtoPayoutRuleTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IUpdatePayoutRuleTypeDtoPayoutRuleTypeEnum {
    NO_EXCEPTIONS = 'NO_EXCEPTIONS',
    WITH_EXCEPTIONS = 'WITH_EXCEPTIONS',
    EXCEPTIONS_ONLY = 'EXCEPTIONS_ONLY'
}


/**
 * Check if a given object implements the IUpdatePayoutRuleTypeDto interface.
 */
export function instanceOfIUpdatePayoutRuleTypeDto(value: object): value is IUpdatePayoutRuleTypeDto {
    if (!('processing_tier_id' in value) || value['processing_tier_id'] === undefined) return false;
    if (!('payout_rule_type' in value) || value['payout_rule_type'] === undefined) return false;
    return true;
}

export function IUpdatePayoutRuleTypeDtoFromJSON(json: any): IUpdatePayoutRuleTypeDto {
    return IUpdatePayoutRuleTypeDtoFromJSONTyped(json, false);
}

export function IUpdatePayoutRuleTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdatePayoutRuleTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'processing_tier_id': json['processing_tier_id'],
        'payout_rule_type': json['payout_rule_type'],
    };
}

export function IUpdatePayoutRuleTypeDtoToJSON(json: any): IUpdatePayoutRuleTypeDto {
    return IUpdatePayoutRuleTypeDtoToJSONTyped(json, false);
}

export function IUpdatePayoutRuleTypeDtoToJSONTyped(value?: IUpdatePayoutRuleTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'processing_tier_id': value['processing_tier_id'],
        'payout_rule_type': value['payout_rule_type'],
    };
}

